import React, { useCallback, useState, useEffect, useRef } from "react";
import {
  DropZone,
  InlineStack,
  FormLayout,
  TextField,
  Thumbnail,
  Checkbox,
  Toast,
  Icon,
  Popover,
  ActionList,
  Button,
  Text,
  Loading,
  ChoiceList,
  Select,
  InlineError,
  ButtonGroup,
  Tooltip,
} from "@shopify/polaris";
import { useParams } from "react-router-dom";
import axios from "../Assets/Lib/axios";
import {
  NoteMinor,
  LanguageIcon,
  MenuVerticalIcon,
  ColorsMajor,
} from "@shopify/polaris-icons";
import { Editor } from "@tinymce/tinymce-react";
import EditorTiny from "./EditorTiny";
import showTools from "../Assets/Images/show-tools.svg";
import hideTools from "../Assets/Images/hide-tools.svg";
import Instruction from "./Instruction";
import { accessEditSections } from "../Helpers";
import axiosDefault from "axios";
import LoadingScreen from "../Components/LoadingScreen";
import instructionImg from "../Assets/Images/instruction-help.svg";

const VideoSection = (props) => {
  const [boolRichTextTools, setBoolRichTextTools] = useState(false);
  let object = JSON.parse(props.object);
  const [data, setData] = useState([]);
  const { id } = useParams();
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const handleSelectChangeLanguage = (value) => {
    setSelectedLanguage(value);
  };
  const [translatedButtonClicked, setTranslatedButtonClicked] = useState(false);
  const handleTranslate = () => {
    setTranslatedButtonClicked(!translatedButtonClicked);
  };
  const handleChangeTitle = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, title: value };
      }
      return obj;
    });
    setData(newState);
  };

  const handleChangeLinkMp4 = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, link_mp4: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeYoutubeId = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, youtubeId: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeSubtitle = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, subtitle: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeLinkMp4Translated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, link_mp4: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeTitleTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, title: value };
      }
      return obj;
    });
    setData(newState);
  };

  const handleChangeYoutubeIdTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, youtubeId: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeSubtitleTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, subtitle: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeLinkOgg = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, link_ogg: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeLinkOggTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, link_ogg: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeLinkWebm = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, link_webm: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeLinkWebmTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, link_webm: value };
      }
      return obj;
    });
    setData(newState);
  };

  const handleChangeVimeoId = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, vimeo_id: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeVimeoIdranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, vimeo_id: value };
      }
      return obj;
    });
    setData(newState);
  };
  const [checked, setChecked] = useState(false);
  const handleChange = (newChecked) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, active: newChecked };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeAutoPlay = (newChecked) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, autoplay: newChecked };
      }
      return obj;
    });
    setData(newState);
  };
  const validImageTypes = [
    "image/gif",
    "image/jpeg",
    "image/png",
    "image/json",
  ];
  const [fileMp4, setFileMp4] = useState();
  const handleDropZoneDropMp4 = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFileMp4((fileMp4) => acceptedFiles[0]),
    []
  );

  const fileUploadMp4 = !fileMp4 && (
    <DropZone.FileUpload actionHint={"Accepts mp4"} />
  );
  const uploadedFileMp4 = fileMp4 && (
    <InlineStack gap="200" align="start" blockAlign="center">
      {/* <Thumbnail
        size="small"
        alt={file.name}
        source={
          validImageTypes.includes(file.type)
            ? window.URL.createObjectURL(file)
            : NoteMinor
        }
      /> */}
      <div className="maxtextwidth">
        {fileMp4.name}{" "}
        <Text variant="bodySm" as="p">
          {fileMp4.size} bytes
        </Text>
      </div>
    </InlineStack>
  );

  const imageKey = useRef("");
  const [isImageUploading, setIsImageUploading] = useState(false);
  const sendFileMp4 = (fileMp4) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "video");
    form_data.append("video[en]", fileMp4[fileMp4.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === "en") {
            return {
              ...obj,
              video_mp4: imageKey.current,
              image_mp4:
                validImageTypes.indexOf(fileMp4[fileMp4.length - 1].type) > 0
                  ? window.URL.createObjectURL(fileMp4[fileMp4.length - 1])
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            };
          }
          return obj;
        });
        setData(newState);
      })
      .catch(function (error) {});
  };

  const [fileMp4Translated, setFileMp4Translated] = useState();
  const handleDropZoneDropMp4Translated = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFileMp4Translated((fileMp4Translated) => acceptedFiles[0]),
    []
  );

  const fileUploadMp4Translated = !fileMp4Translated && (
    <DropZone.FileUpload actionHint={"Accepts mp4"} />
  );
  const uploadedFileMp4Translated = fileMp4Translated && (
    <InlineStack gap="200" align="start" blockAlign="center">
      {/* <Thumbnail
        size="small"
        alt={file.name}
        source={
          validImageTypes.includes(file.type)
            ? window.URL.createObjectURL(file)
            : NoteMinor
        }
      /> */}
      <div className="maxtextwidth">
        {fileMp4Translated.name}{" "}
        <Text variant="bodySm" as="p">
          {fileMp4Translated.size} bytes
        </Text>
      </div>
    </InlineStack>
  );

  const sendFileMp4Translated = (fileMp4Translated) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "video");
    form_data.append(
      `video[${selectedLanguage}]`,
      fileMp4Translated[fileMp4Translated.length - 1]
    );
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === selectedLanguage) {
            return {
              ...obj,
              video_mp4: imageKey.current,
              image_mp4:
                validImageTypes.indexOf(
                  fileMp4Translated[fileMp4Translated.length - 1].type
                ) > 0
                  ? window.URL.createObjectURL(
                      fileMp4Translated[fileMp4Translated.length - 1]
                    )
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            };
          }
          return obj;
        });
        setData(newState);
      })
      .catch(function (error) {});
  };

  const [fileMp4Mobile, setFileMp4Mobile] = useState();
  const handleDropZoneDropMp4Mobile = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFileMp4Mobile((fileMp4Mobiel) => acceptedFiles[0]),
    []
  );

  const fileUploadMp4Mobile = !fileMp4Mobile && (
    <DropZone.FileUpload actionHint={"Accepts mp4"} />
  );
  const uploadedFileMp4Mobile = fileMp4Mobile && (
    <InlineStack gap="200" align="start" blockAlign="center">
      {/* <Thumbnail
        size="small"
        alt={file.name}
        source={
          validImageTypes.includes(file.type)
            ? window.URL.createObjectURL(file)
            : NoteMinor
        }
      /> */}
      <div className="maxtextwidth">
        {fileMp4Mobile.name}{" "}
        <Text variant="bodySm" as="p">
          {fileMp4Mobile.size} bytes
        </Text>
      </div>
    </InlineStack>
  );
  const sendFileMp4Mobile = (fileMp4Mobile) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "video");
    form_data.append("video[en]", fileMp4Mobile[fileMp4Mobile.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === "en") {
            return {
              ...obj,
              video_mp4_mobile: imageKey.current,
              image_mp4_mobile:
                validImageTypes.indexOf(
                  fileMp4Mobile[fileMp4Mobile.length - 1].type
                ) > 0
                  ? window.URL.createObjectURL(
                      fileMp4Mobile[fileMp4Mobile.length - 1]
                    )
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            };
          }
          return obj;
        });
        setData(newState);
      })
      .catch(function (error) {});
  };

  const [fileMp4TranslatedMobile, setFileMp4TranslatedMobile] = useState();
  const handleDropZoneDropMp4TranslatedMobile = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFileMp4Translated((fileMp4TranslatedMobile) => acceptedFiles[0]),
    []
  );

  const fileUploadMp4TranslatedMobile = !fileMp4TranslatedMobile && (
    <DropZone.FileUpload actionHint={"Accepts mp4"} />
  );
  const uploadedFileMp4TranslatedMobile = fileMp4TranslatedMobile && (
    <InlineStack gap="200" align="start" blockAlign="center">
      {/* <Thumbnail
        size="small"
        alt={file.name}
        source={
          validImageTypes.includes(file.type)
            ? window.URL.createObjectURL(file)
            : NoteMinor
        }
      /> */}
      <div className="maxtextwidth">
        {fileMp4TranslatedMobile.name}{" "}
        <Text variant="bodySm" as="p">
          {fileMp4TranslatedMobile.size} bytes
        </Text>
      </div>
    </InlineStack>
  );

  const sendFileMp4TranslatedMobile = (fileMp4TranslatedMobile) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "video");
    form_data.append(
      `video[${selectedLanguage}]`,
      fileMp4TranslatedMobile[fileMp4TranslatedMobile.length - 1]
    );
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === selectedLanguage) {
            return {
              ...obj,
              video_mp4_mobile: imageKey.current,
              image_mp4_mobile:
                validImageTypes.indexOf(
                  fileMp4TranslatedMobile[fileMp4TranslatedMobile.length - 1]
                    .type
                ) > 0
                  ? window.URL.createObjectURL(
                      fileMp4TranslatedMobile[
                        fileMp4TranslatedMobile.length - 1
                      ]
                    )
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            };
          }
          return obj;
        });
        setData(newState);
      })
      .catch(function (error) {});
  };

  const [fileOgg, setFileOgg] = useState();
  const handleDropZoneDropOgg = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFileOgg((fileOgg) => acceptedFiles[0]),
    []
  );

  const fileUploadOgg = !fileOgg && (
    <DropZone.FileUpload actionHint={"Accepts ogg"} />
  );
  const uploadedFileOgg = fileOgg && (
    <InlineStack gap="200" align="start" blockAlign="center">
      {/* <Thumbnail
        size="small"
        alt={file.name}
        source={
          validImageTypes.includes(file.type)
            ? window.URL.createObjectURL(file)
            : NoteMinor
        }
      /> */}
      <div className="maxtextwidth">
        {fileOgg.name}{" "}
        <Text variant="bodySm" as="p">
          {fileOgg.size} bytes
        </Text>
      </div>
    </InlineStack>
  );

  const sendFileOgg = (fileOgg) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "video");
    form_data.append("video[en]", fileOgg[fileOgg.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === "en") {
            return {
              ...obj,
              video_ogg: imageKey.current,
              image_ogg:
                validImageTypes.indexOf(fileOgg[fileOgg.length - 1].type) > 0
                  ? window.URL.createObjectURL(fileOgg[fileOgg.length - 1])
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            };
          }
          return obj;
        });
        setData(newState);
      })
      .catch(function (error) {});
  };

  const [fileOggTranslated, setFileOggTranslated] = useState();
  const handleDropZoneDropOggTranslated = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFileOggTranslated((fileOggTranslated) => acceptedFiles[0]),
    []
  );

  const fileUploadOggTranslated = !fileOggTranslated && (
    <DropZone.FileUpload actionHint={"Accepts ogg"} />
  );
  const uploadedFileOggTranslated = fileOggTranslated && (
    <InlineStack gap="200" align="start" blockAlign="center">
      {/* <Thumbnail
        size="small"
        alt={file.name}
        source={
          validImageTypes.includes(file.type)
            ? window.URL.createObjectURL(file)
            : NoteMinor
        }
      /> */}
      <div className="maxtextwidth">
        {fileOggTranslated.name}{" "}
        <Text variant="bodySm" as="p">
          {fileOggTranslated.size} bytes
        </Text>
      </div>
    </InlineStack>
  );

  const sendFileOggTranslated = (fileOggTranslated) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "video");
    form_data.append(
      `video[${selectedLanguage}]`,
      fileOggTranslated[fileOggTranslated.length - 1]
    );
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === selectedLanguage) {
            return {
              ...obj,
              video_ogg: imageKey.current,
              image_ogg:
                validImageTypes.indexOf(
                  fileOggTranslated[fileOggTranslated.length - 1].type
                ) > 0
                  ? window.URL.createObjectURL(
                      fileOggTranslated[fileOggTranslated.length - 1]
                    )
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            };
          }
          return obj;
        });
        setData(newState);
      })
      .catch(function (error) {});
  };

  const [fileOggMobile, setFileOggMobile] = useState();
  const handleDropZoneDropOggMobile = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFileOggMobile((fileOggMobile) => acceptedFiles[0]),
    []
  );

  const fileUploadOggMobile = !fileOggMobile && (
    <DropZone.FileUpload actionHint={"Accepts ogg"} />
  );
  const uploadedFileOggMobile = fileOggMobile && (
    <InlineStack gap="200" align="start" blockAlign="center">
      {/* <Thumbnail
        size="small"
        alt={file.name}
        source={
          validImageTypes.includes(file.type)
            ? window.URL.createObjectURL(file)
            : NoteMinor
        }
      /> */}
      <div className="maxtextwidth">
        {fileOggMobile.name}{" "}
        <Text variant="bodySm" as="p">
          {fileOggMobile.size} bytes
        </Text>
      </div>
    </InlineStack>
  );

  const sendFileOggMobile = (fileOggMobile) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "video");
    form_data.append("video[en]", fileOggMobile[fileOggMobile.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === "en") {
            return {
              ...obj,
              video_ogg_mobile: imageKey.current,
              image_ogg_mobile:
                validImageTypes.indexOf(
                  fileOggMobile[fileOggMobile.length - 1].type
                ) > 0
                  ? window.URL.createObjectURL(
                      fileOggMobile[fileOggMobile.length - 1]
                    )
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            };
          }
          return obj;
        });
        setData(newState);
      })
      .catch(function (error) {});
  };

  const [fileOggTranslatedMobile, setFileOggTranslatedMobile] = useState();
  const handleDropZoneDropOggTranslatedMobile = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFileOggTranslatedMobile((fileOggTranslatedMobile) => acceptedFiles[0]),
    []
  );

  const fileUploadOggTranslatedMobile = !fileOggTranslatedMobile && (
    <DropZone.FileUpload actionHint={"Accepts ogg"} />
  );
  const uploadedFileOggTranslatedMobile = fileOggTranslatedMobile && (
    <InlineStack gap="200" align="start" blockAlign="center">
      {/* <Thumbnail
        size="small"
        alt={file.name}
        source={
          validImageTypes.includes(file.type)
            ? window.URL.createObjectURL(file)
            : NoteMinor
        }
      /> */}
      <div className="maxtextwidth">
        {fileOggTranslatedMobile.name}{" "}
        <Text variant="bodySm" as="p">
          {fileOggTranslatedMobile.size} bytes
        </Text>
      </div>
    </InlineStack>
  );

  const sendFileOggTranslatedMobile = (fileOggTranslatedMobile) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "video");
    form_data.append(
      `video[${selectedLanguage}]`,
      fileOggTranslatedMobile[fileOggTranslatedMobile.length - 1]
    );
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === selectedLanguage) {
            return {
              ...obj,
              video_ogg_mobile: imageKey.current,
              image_ogg_mobile:
                validImageTypes.indexOf(
                  fileOggTranslatedMobile[fileOggTranslatedMobile.length - 1]
                    .type
                ) > 0
                  ? window.URL.createObjectURL(
                      fileOggTranslatedMobile[
                        fileOggTranslatedMobile.length - 1
                      ]
                    )
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            };
          }
          return obj;
        });
        setData(newState);
      })
      .catch(function (error) {});
  };

  const [fileWebm, setFileWebm] = useState();
  const handleDropZoneDropWebm = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFileWebm((fileWebm) => acceptedFiles[0]),
    []
  );

  const fileUploadWebm = !fileWebm && (
    <DropZone.FileUpload actionHint={"Accepts webm"} />
  );
  const uploadedFileWebm = fileWebm && (
    <InlineStack gap="200" align="start" blockAlign="center">
      {/* <Thumbnail
        size="small"
        alt={file.name}
        source={
          validImageTypes.includes(file.type)
            ? window.URL.createObjectURL(file)
            : NoteMinor
        }
      /> */}
      <div className="maxtextwidth">
        {fileWebm.name}{" "}
        <Text variant="bodySm" as="p">
          {fileWebm.size} bytes
        </Text>
      </div>
    </InlineStack>
  );

  const sendFileWebm = (fileWebm) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "video");
    form_data.append("video[en]", fileWebm[fileWebm.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === "en") {
            return {
              ...obj,
              video_webm: imageKey.current,
              image_webm:
                validImageTypes.indexOf(fileWebm[fileWebm.length - 1].type) > 0
                  ? window.URL.createObjectURL(fileWebm[fileWebm.length - 1])
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            };
          }
          return obj;
        });
        setData(newState);
      })
      .catch(function (error) {});
  };

  const [fileWebmTranslated, setFileWebmTranslated] = useState();
  const handleDropZoneDropWebmTranslated = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFileWebmTranslated((fileWebmTranslated) => acceptedFiles[0]),
    []
  );

  const fileUploadWebmTranslated = !fileWebmTranslated && (
    <DropZone.FileUpload actionHint={"Accepts webm"} />
  );
  const uploadedFileWebmTranslated = fileWebmTranslated && (
    <InlineStack gap="200" align="start" blockAlign="center">
      {/* <Thumbnail
        size="small"
        alt={file.name}
        source={
          validImageTypes.includes(file.type)
            ? window.URL.createObjectURL(file)
            : NoteMinor
        }
      /> */}
      <div className="maxtextwidth">
        {fileWebmTranslated.name}{" "}
        <Text variant="bodySm" as="p">
          {fileWebmTranslated.size} bytes
        </Text>
      </div>
    </InlineStack>
  );

  const sendFileWebmTranslated = (fileWebmTranslated) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "video");
    form_data.append(
      `video[${selectedLanguage}]`,
      fileWebmTranslated[fileWebmTranslated.length - 1]
    );
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === selectedLanguage) {
            return {
              ...obj,
              video_webm: imageKey.current,
              image_webm:
                validImageTypes.indexOf(
                  fileWebmTranslated[fileWebmTranslated.length - 1].type
                ) > 0
                  ? window.URL.createObjectURL(
                      fileWebmTranslated[fileWebmTranslated.length - 1]
                    )
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            };
          }
          return obj;
        });
        setData(newState);
      })
      .catch(function (error) {});
  };

  const [fileWebmMobile, setFileWebmMobile] = useState();
  const handleDropZoneDropWebmMobile = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFileWebmMobile((fileWebmMobile) => acceptedFiles[0]),
    []
  );

  const fileUploadWebmMobile = !fileWebmMobile && (
    <DropZone.FileUpload actionHint={"Accepts webm"} />
  );
  const uploadedFileWebmMobile = fileWebmMobile && (
    <InlineStack gap="200" align="start" blockAlign="center">
      {/* <Thumbnail
        size="small"
        alt={file.name}
        source={
          validImageTypes.includes(file.type)
            ? window.URL.createObjectURL(file)
            : NoteMinor
        }
      /> */}
      <div className="maxtextwidth">
        {fileWebmMobile.name}{" "}
        <Text variant="bodySm" as="p">
          {fileWebmMobile.size} bytes
        </Text>
      </div>
    </InlineStack>
  );

  const sendFileWebmMobile = (fileWebmMobile) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "video");
    form_data.append("video[en]", fileWebmMobile[fileWebmMobile.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === "en") {
            return {
              ...obj,
              video_webm_mobile: imageKey.current,
              image_webm_mobile:
                validImageTypes.indexOf(
                  fileWebmMobile[fileWebmMobile.length - 1].type
                ) > 0
                  ? window.URL.createObjectURL(
                      fileWebmMobile[fileWebm.length - 1]
                    )
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            };
          }
          return obj;
        });
        setData(newState);
      })
      .catch(function (error) {});
  };

  const [fileWebmTranslatedMobile, setFileWebmTranslatedMobile] = useState();
  const handleDropZoneDropWebmTranslatedMobile = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFileWebmTranslatedMobile(
        (fileWebmTranslatedMobile) => acceptedFiles[0]
      ),
    []
  );

  const fileUploadWebmTranslatedMobile = !fileWebmTranslatedMobile && (
    <DropZone.FileUpload actionHint={"Accepts webm"} />
  );
  const uploadedFileWebmTranslatedMobile = fileWebmTranslatedMobile && (
    <InlineStack gap="200" align="start" blockAlign="center">
      {/* <Thumbnail
        size="small"
        alt={file.name}
        source={
          validImageTypes.includes(file.type)
            ? window.URL.createObjectURL(file)
            : NoteMinor
        }
      /> */}
      <div className="maxtextwidth">
        {fileWebmTranslatedMobile.name}{" "}
        <Text variant="bodySm" as="p">
          {fileWebmTranslatedMobile.size} bytes
        </Text>
      </div>
    </InlineStack>
  );

  const sendFileWebmTranslatedMobile = (fileWebmTranslatedMobile) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "video");
    form_data.append(
      `video[${selectedLanguage}]`,
      fileWebmTranslatedMobile[fileWebmTranslatedMobile.length - 1]
    );
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === selectedLanguage) {
            return {
              ...obj,
              video_webm_mobile: imageKey.current,
              image_webm_mobile:
                validImageTypes.indexOf(
                  fileWebmTranslatedMobile[fileWebmTranslatedMobile.length - 1]
                    .type
                ) > 0
                  ? window.URL.createObjectURL(
                      fileWebmTranslatedMobile[
                        fileWebmTranslatedMobile.length - 1
                      ]
                    )
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            };
          }
          return obj;
        });
        setData(newState);
      })
      .catch(function (error) {});
  };

  const handleChangeTemplate = (newValue) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, template: newValue };
      }
      return obj;
    });
    setData(newState);
  };
  useEffect(() => {
    object = JSON.parse(props.object);
    setData(
      props.languagesArray
        .concat([{ label: "English", value: "en" }])
        .map((element, index) => {
          return {
            language: element.value,
            instruction: object?.instructions ? object?.instructions : "",
            title:
              object?.title && object?.title[element.value]
                ? object?.title[element.value]
                : "",
            subtitle:
              object?.subtitle && object?.subtitle[element.value]
                ? object?.subtitle[element.value]
                : "",
            vimeoId:
              object?.details?.vimeo_id &&
              object?.details?.vimeo_id[element.value]
                ? object?.details?.vimeo_id[element.value]
                : "",
            youtubeId:
              object?.details?.youtube_id &&
              object?.details?.youtube_id[element.value]
                ? object?.details?.youtube_id[element.value]
                : "",
            link_mp4:
              object?.details?.link_mp4 &&
              object?.details?.link_mp4[element.value]
                ? object?.details?.link_mp4[element.value]
                : "",
            vimeo_id:
              object?.details?.vimeo_id &&
              object?.details?.vimeo_id[element.value]
                ? object?.details?.vimeo_id[element.value]
                : "",
            link_ogg:
              object?.details?.link_ogg &&
              object?.details?.link_ogg[element.value]
                ? object?.details?.link_ogg[element.value]
                : "",
            link_webm:
              object?.details?.link_webm &&
              object?.details?.link_webm[element.value]
                ? object?.details?.link_webm[element.value]
                : "",
            video_mp4: "",
            video_ogg: "",
            video_webm: "",
            video_mp4_mobile: "",
            video_ogg_mobile: "",
            video_webm_mobile: "",
            image_mp4:
              object?.details?.file_mp4 &&
              object?.details?.file_mp4[element.value]
                ? "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304"
                : "",
            image_ogg:
              object?.details?.file_ogg &&
              object?.details?.file_ogg[element.value]
                ? "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304"
                : "",
            image_webm:
              object?.details?.file_webm &&
              object?.details?.file_webm[element.value]
                ? "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304"
                : "",

            image_mp4_mobile:
              object?.details?.mobile_file_mp4 &&
              object?.details?.mobile_file_mp4[element.value]
                ? "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304"
                : "",
            image_ogg_mobile:
              object?.details?.mobile_file_ogg &&
              object?.details?.mobile_file_ogg[element.value]
                ? "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304"
                : "",
            image_webm_mobile:
              object?.details?.mobile_file_webm &&
              object?.details?.mobile_file_webm[element.value]
                ? "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304"
                : "",

            active: object?.details?.is_active ? true : false,
            autoplay: object?.details?.is_autoplay ? true : false,
            template:
              object?.template_id !== null
                ? String(object?.template_id)
                : props.templates[0]?.id
                ? props.templates[0]?.id
                : "",
            fileImage: "",
            fileImage_mobile: "",
            image:
              object?.details?.thumbnail &&
              object?.details?.thumbnail[element.value]
                ? object?.details?.thumbnail[element.value]
                : "",
            image_mobile:
              object?.details?.mobile_thumbnail &&
              object?.details?.mobile_thumbnail[element.value]
                ? object?.details?.mobile_thumbnail[element.value]
                : "",
          };
        })
    );
  }, [props.object]);
  const [popoverActive, setPopoverActive] = useState(false);
  const togglePopoverActive = useCallback(
    () => setPopoverActive((popoverActive) => !popoverActive),
    []
  );
  const activator = (
    <Button onClick={togglePopoverActive} plain>
      <Icon source={MenuVerticalIcon} />
    </Button>
  );

  const [file, setFile] = useState();
  const handleDropZoneDrop = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFile((file) => acceptedFiles[0]),
    []
  );

  const fileUpload = !file && (
    <DropZone.FileUpload actionHint={"Accepts pngs, jpegs, svgs and jsons"} />
  );
  const uploadedFile = file && (
    <InlineStack gap="200" align="start" blockAlign="center">
      {/* Uncomment if using thumbnail */}
      {/*
    <Thumbnail
      size="small"
      alt={file.name}
      source={
        validImageTypes.includes(file.type)
          ? window.URL.createObjectURL(file)
          : NoteMinor
      }
    />
    */}
      <div className="maxtextwidth">
        {file.name}{" "}
        <Text variant="bodySm" as="p">
          {file.size} bytes
        </Text>
      </div>
    </InlineStack>
  );
  const [imageError, setImageError] = useState("");

  const sendImage = (file) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "video");
    form_data.append("thumbnail[en]", file[file.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === "en") {
            return {
              ...obj,
              fileImage: imageKey.current,
              image:
                validImageTypes.indexOf(file[file.length - 1].type) > 0
                  ? window.URL.createObjectURL(file[file.length - 1])
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            };
          }
          return obj;
        });
        setData(newState);
        setImageError("");
      })
      .catch(function (error) {});
  };

  const [fileTranslated, setFileTranslated] = useState();
  const handleDropZoneDropTranslated = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFileTranslated((fileTranslated) => acceptedFiles[0]),
    []
  );
  const fileUploadTranslated = !fileTranslated && (
    <DropZone.FileUpload actionHint={"Accepts pngs, jpegs, svgs and jsons"} />
  );
  const uploadedFileTranslated = fileTranslated && (
    <InlineStack gap="200" align="start" blockAlign="center">
      {/* <Thumbnail
        size="small"
        alt={file.name}
        source={
          validImageTypes.includes(file.type)
            ? window.URL.createObjectURL(file)
            : NoteMinor
        }
      /> */}
      <div className="maxtextwidth">
        {fileTranslated.name}{" "}
        <Text variant="bodySm" as="p">
          {fileTranslated.size} bytes
        </Text>
      </div>
    </InlineStack>
  );
  const sendImageTranslated = (fileTranslated) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "video");
    form_data.append(
      `thumbnail[${selectedLanguage}]`,
      fileTranslated[fileTranslated.length - 1]
    );
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === selectedLanguage) {
            return {
              ...obj,
              fileImage: imageKey.current,
              image:
                validImageTypes.indexOf(
                  fileTranslated[fileTranslated.length - 1].type
                ) > 0
                  ? window.URL.createObjectURL(
                      fileTranslated[fileTranslated.length - 1]
                    )
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            };
          }
          return obj;
        });
        setData(newState);
      })
      .catch(function (error) {});
  };

  const [fileMobile, setFileMobile] = useState();
  const handleDropZoneDropMobile = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFileMobile((fileMobile) => acceptedFiles[0]),
    []
  );

  const fileUploadMobile = !fileMobile && (
    <DropZone.FileUpload actionHint={"Accepts pngs, jpegs, svgs and jsons"} />
  );
  const uploadedFileMobile = fileMobile && (
    <InlineStack gap="200" align="start" blockAlign="center">
      {/* <Thumbnail
        size="small"
        alt={file.name}
        source={
          validImageTypes.includes(file.type)
            ? window.URL.createObjectURL(file)
            : NoteMinor
        }
      /> */}
      <div className="maxtextwidth">
        {fileMobile.name}{" "}
        <Text variant="bodySm" as="p">
          {fileMobile.size} bytes
        </Text>
      </div>
    </InlineStack>
  );

  const sendImageMobile = (fileMobile) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "video");
    form_data.append("thumbnail[en]", fileMobile[fileMobile.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === "en") {
            return {
              ...obj,
              fileImage_mobile: imageKey.current,
              image_mobile:
                validImageTypes.indexOf(
                  fileMobile[fileMobile.length - 1].type
                ) > 0
                  ? window.URL.createObjectURL(
                      fileMobile[fileMobile.length - 1]
                    )
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            };
          }
          return obj;
        });
        setData(newState);
        setImageError("");
      })
      .catch(function (error) {});
  };

  const [fileTranslatedMobile, setFileTranslatedMobile] = useState();
  const handleDropZoneDropTranslatedMobile = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFileTranslatedMobile((fileTranslated) => acceptedFiles[0]),
    []
  );
  const fileUploadTranslatedMobile = !fileTranslatedMobile && (
    <DropZone.FileUpload actionHint={"Accepts pngs, jpegs, svgs and jsons"} />
  );
  const uploadedFileTranslatedMobile = fileTranslatedMobile && (
    <InlineStack gap="200" align="start" blockAlign="center">
      {/* <Thumbnail
        size="small"
        alt={file.name}
        source={
          validImageTypes.includes(file.type)
            ? window.URL.createObjectURL(file)
            : NoteMinor
        }
      /> */}
      <div className="maxtextwidth">
        {fileTranslatedMobile.name}{" "}
        <Text variant="bodySm" as="p">
          {fileTranslatedMobile.size} bytes
        </Text>
      </div>
    </InlineStack>
  );
  const sendImageTranslatedMobile = (fileTranslatedMobile) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "video");
    form_data.append(
      `thumbnail[${selectedLanguage}]`,
      fileTranslatedMobile[fileTranslatedMobile.length - 1]
    );
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === selectedLanguage) {
            return {
              ...obj,
              fileImage_mobile: imageKey.current,
              image_mobile:
                validImageTypes.indexOf(
                  fileTranslatedMobile[fileTranslatedMobile.length - 1].type
                ) > 0
                  ? window.URL.createObjectURL(
                      fileTranslatedMobile[fileTranslatedMobile.length - 1]
                    )
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            };
          }
          return obj;
        });
        setData(newState);
      })
      .catch(function (error) {});
  };

  return (
    <FormLayout>
      {/* <Instruction
        text={
          findArrayElementByLanguage(data, "en") &&
          findArrayElementByLanguage(data, "en").instruction
        }
        pageId={id}
        sectionId={props.sectionId}
        handleRefreshSections={props.handleRefreshSections}
      /> */}
      <div style={{ float: "right" }}>
        <ButtonGroup>
          <Button
            onClick={() => {
              setBoolRichTextTools(!boolRichTextTools);
            }}
            plain
          >
            <img src={boolRichTextTools ? showTools : hideTools} width={22} />
          </Button>
          <Button
            plain
            onClick={handleTranslate}
            icon={!translatedButtonClicked ? LanguageIcon : ""}
          >
            {translatedButtonClicked ? "Edit English" : "Translate"}
          </Button>
          {/* <Button
            plain
            onClick={() => props.handleCustomizeStyles()}
            icon={ColorsMajor}
          >
            Customize Styles
          </Button> */}
        </ButtonGroup>
      </div>

      <table>
        <tbody>
          <tr>
            <Checkbox
              label="Auto-Play"
              checked={
                findArrayElementByLanguage(data, "en") &&
                findArrayElementByLanguage(data, "en").autoplay
              }
              onChange={handleChangeAutoPlay}
            />
          </tr>
          <tr>
            <th>
              <Text variant="bodyMd" as="p" fontWeight="medium"></Text>
            </th>
            <th>
              <Text variant="bodyMd" as="p" fontWeight="medium"></Text>
            </th>
            {translatedButtonClicked && (
              <th>
                <Select
                  options={props.languagesArray}
                  onChange={handleSelectChangeLanguage}
                  value={selectedLanguage}
                  placeholder="Please select a language"
                />
              </th>
            )}
          </tr>
          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Title
              </Text>
            </td>
            <td>
              <TextField
                value={
                  findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").title
                }
                onChange={handleChangeTitle}
                disabled={translatedButtonClicked}
              />
              {/* <EditorTiny
                boolRichTextTools={boolRichTextTools}
                value={
                  findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").title
                }
                handleChangeValue={handleChangeTitle}
                disabled={translatedButtonClicked}
                height={100}
              /> */}
            </td>
            {translatedButtonClicked && (
              <td>
                <TextField
                  value={
                    findArrayElementByLanguage(data, selectedLanguage) &&
                    findArrayElementByLanguage(data, selectedLanguage).title
                  }
                  onChange={handleChangeTitleTranslated}
                />
                {/* <EditorTiny
                  boolRichTextTools={boolRichTextTools}
                  value={
                    findArrayElementByLanguage(data, selectedLanguage) &&
                    findArrayElementByLanguage(data, selectedLanguage).title
                  }
                  handleChangeValue={handleChangeTitleTranslated}
                  height={100}
                /> */}
              </td>
            )}
          </tr>
          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Subtitle
              </Text>
            </td>
            <td>
              <TextField
                value={
                  findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").subtitle
                }
                onChange={handleChangeSubtitle}
                disabled={translatedButtonClicked}
              />
              {/* <EditorTiny
                boolRichTextTools={boolRichTextTools}
                value={
                  findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").subtitle
                }
                handleChangeValue={handleChangeSubtitle}
                disabled={translatedButtonClicked}
                height={100}
              /> */}

              {/* <Editor
                disabled={translatedButtonClicked}
                apiKey="7e5qugyswmfji644700m0pos9pozwpesrtdbyflsqx2s0zsf"
                value={
                  findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").text
                }
                init={{
                  readonly: 1,
                  branding: false,
                  height: 200,
                  menubar: false,
                  plugins: [
                    "advlist autolink lists link image charmap print preview anchor",
                    "searchreplace visualblocks code fullscreen",
                    "insertdatetime media table paste code help wordcount",
                  ],
                  toolbar:
                    "undo redo | formatselect | bold italic backcolor | \
alignleft aligncenter alignright alignjustify | \
bullist numlist outdent indent | removeformat | help|code",
                }}
                onEditorChange={handleChangeText}
              /> */}
            </td>
            {translatedButtonClicked && (
              <td>
                <TextField
                  value={
                    findArrayElementByLanguage(data, selectedLanguage) &&
                    findArrayElementByLanguage(data, selectedLanguage).subtitle
                  }
                  onChange={handleChangeSubtitleTranslated}
                />
                {/* <EditorTiny
                  boolRichTextTools={boolRichTextTools}
                  value={
                    findArrayElementByLanguage(data, selectedLanguage) &&
                    findArrayElementByLanguage(data, selectedLanguage).subtitle
                  }
                  handleChangeValue={handleChangeSubtitleTranslated}
                  height={100}
                /> */}
                {/* <Editor
                  apiKey="7e5qugyswmfji644700m0pos9pozwpesrtdbyflsqx2s0zsf"
                  value={
                    findArrayElementByLanguage(data, selectedLanguage) &&
                    findArrayElementByLanguage(data, selectedLanguage).text
                  }
                  init={{
                    branding: false,
                    height: 200,
                    menubar: false,
                    plugins: [
                      "advlist autolink lists link image charmap print preview anchor",
                      "searchreplace visualblocks code fullscreen",
                      "insertdatetime media table paste code help wordcount",
                    ],
                    toolbar:
                      "undo redo | formatselect | bold italic backcolor | \
alignleft aligncenter alignright alignjustify | \
bullist numlist outdent indent | removeformat | help|code",
                  }}
                  onEditorChange={handleChangeTextTranslated}
                /> */}
              </td>
            )}
          </tr>
          {/* <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Vimeo ID
              </Text>
            </td>
            <td>
              <TextField
                value={
                  findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").vimeoId
                }
                onChange={handleChangeVimeoId}
                disabled={translatedButtonClicked}
              />
            </td>
            {translatedButtonClicked && (
              <td>
                <TextField
                  value={
                    findArrayElementByLanguage(data, selectedLanguage) &&
                    findArrayElementByLanguage(data, selectedLanguage).vimeoId
                  }
                  onChange={handleChangeVimeoIdTranslated}
                />
              </td>
            )}
          </tr>
          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Youtube Id
              </Text>
            </td>
            <td>
              <TextField
                value={
                  findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").youtubeId
                }
                onChange={handleChangeYoutubeId}
                disabled={translatedButtonClicked}
              />
            </td>
            {translatedButtonClicked && (
              <td>
                <TextField
                  value={
                    findArrayElementByLanguage(data, selectedLanguage) &&
                    findArrayElementByLanguage(data, selectedLanguage).youtubeId
                  }
                  onChange={handleChangeYoutubeIdTranslated}
                />
              </td>
            )}
          </tr> */}

          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Link Mp4
              </Text>
            </td>
            <td>
              <TextField
                value={
                  findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").link_mp4
                }
                onChange={handleChangeLinkMp4}
                disabled={translatedButtonClicked}
              />
            </td>
            {translatedButtonClicked && (
              <td>
                <TextField
                  value={
                    findArrayElementByLanguage(data, selectedLanguage) &&
                    findArrayElementByLanguage(data, selectedLanguage).link_mp4
                  }
                  onChange={handleChangeLinkMp4Translated}
                />
              </td>
            )}
          </tr>

          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Video Mp4 (Desktop)
              </Text>
            </td>
            <td>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                }}
              >
                <div style={{ float: "left" }}>
                  <Thumbnail
                    size="large"
                    source={
                      findArrayElementByLanguage(data, "en") &&
                      findArrayElementByLanguage(data, "en").image_mp4
                        ? findArrayElementByLanguage(data, "en").image_mp4
                        : ""
                    }
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    marginLeft: "10px",
                  }}
                >
                  <DropZone
                    accept=".mp4"
                    //   type="file"
                    allowMultiple={false}
                    onDrop={handleDropZoneDropMp4}
                    onDropAccepted={sendFileMp4}
                  >
                    {uploadedFileMp4}
                    {fileUploadMp4}
                  </DropZone>
                </div>
              </div>
            </td>
            {translatedButtonClicked && (
              <td>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                  }}
                >
                  <div style={{ float: "left" }}>
                    <Thumbnail
                      size="large"
                      source={
                        findArrayElementByLanguage(data, selectedLanguage) &&
                        findArrayElementByLanguage(data, selectedLanguage)
                          .image_mp4
                          ? findArrayElementByLanguage(data, selectedLanguage)
                              .image_mp4
                          : ""
                      }
                    />
                  </div>
                  <div
                    style={{
                      width: "100%",
                      marginLeft: "10px",
                    }}
                  >
                    <DropZone
                      accept=".mp4"
                      //   type="file"
                      allowMultiple={false}
                      onDrop={handleDropZoneDropMp4Translated}
                      onDropAccepted={sendFileMp4Translated}
                    >
                      {uploadedFileMp4Translated}
                      {fileUploadMp4Translated}
                    </DropZone>
                  </div>
                </div>
              </td>
            )}
          </tr>

          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Video Mp4 (Mobile)
              </Text>
            </td>
            <td>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                }}
              >
                <div style={{ float: "left" }}>
                  <Thumbnail
                    size="large"
                    source={
                      findArrayElementByLanguage(data, "en") &&
                      findArrayElementByLanguage(data, "en").image_mp4_mobile
                        ? findArrayElementByLanguage(data, "en")
                            .image_mp4_mobile
                        : ""
                    }
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    marginLeft: "10px",
                  }}
                >
                  <DropZone
                    accept=".mp4"
                    //   type="file"
                    allowMultiple={false}
                    onDrop={handleDropZoneDropMp4Mobile}
                    onDropAccepted={sendFileMp4Mobile}
                  >
                    {uploadedFileMp4Mobile}
                    {fileUploadMp4Mobile}
                  </DropZone>
                </div>
              </div>
            </td>
            {translatedButtonClicked && (
              <td>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                  }}
                >
                  <div style={{ float: "left" }}>
                    <Thumbnail
                      size="large"
                      source={
                        findArrayElementByLanguage(data, selectedLanguage) &&
                        findArrayElementByLanguage(data, selectedLanguage)
                          .image_mp4_mobile
                          ? findArrayElementByLanguage(data, selectedLanguage)
                              .image_mp4_mobile
                          : ""
                      }
                    />
                  </div>
                  <div
                    style={{
                      width: "100%",
                      marginLeft: "10px",
                    }}
                  >
                    <DropZone
                      accept=".mp4"
                      //   type="file"
                      allowMultiple={false}
                      onDrop={handleDropZoneDropMp4TranslatedMobile}
                      onDropAccepted={sendFileMp4TranslatedMobile}
                    >
                      {uploadedFileMp4TranslatedMobile}
                      {fileUploadMp4TranslatedMobile}
                    </DropZone>
                  </div>
                </div>
              </td>
            )}
          </tr>

          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Link Ogg
              </Text>
            </td>
            <td>
              <TextField
                value={
                  findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").link_ogg
                }
                onChange={handleChangeLinkOgg}
                disabled={translatedButtonClicked}
              />
            </td>
            {translatedButtonClicked && (
              <td>
                <TextField
                  value={
                    findArrayElementByLanguage(data, selectedLanguage) &&
                    findArrayElementByLanguage(data, selectedLanguage).link_ogg
                  }
                  onChange={handleChangeLinkOggTranslated}
                />
              </td>
            )}
          </tr>

          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Video Ogg (Desktop)
              </Text>
            </td>
            <td>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                }}
              >
                <div style={{ float: "left" }}>
                  <Thumbnail
                    size="large"
                    source={
                      findArrayElementByLanguage(data, "en") &&
                      findArrayElementByLanguage(data, "en").image_ogg
                        ? findArrayElementByLanguage(data, "en").image_ogg
                        : ""
                    }
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    marginLeft: "10px",
                  }}
                >
                  <DropZone
                    accept=".ogg"
                    //   type="file"
                    allowMultiple={false}
                    onDrop={handleDropZoneDropOgg}
                    onDropAccepted={sendFileOgg}
                  >
                    {uploadedFileOgg}
                    {fileUploadOgg}
                  </DropZone>
                </div>
              </div>
            </td>
            {translatedButtonClicked && (
              <td>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                  }}
                >
                  <div style={{ float: "left" }}>
                    <Thumbnail
                      size="large"
                      source={
                        findArrayElementByLanguage(data, selectedLanguage) &&
                        findArrayElementByLanguage(data, selectedLanguage)
                          .image_ogg
                          ? findArrayElementByLanguage(data, selectedLanguage)
                              .image_ogg
                          : ""
                      }
                    />
                  </div>
                  <div
                    style={{
                      width: "100%",
                      marginLeft: "10px",
                    }}
                  >
                    <DropZone
                      accept=".ogg"
                      //   type="file"
                      allowMultiple={false}
                      onDrop={handleDropZoneDropOggTranslated}
                      onDropAccepted={sendFileOggTranslated}
                    >
                      {uploadedFileOggTranslated}
                      {fileUploadOggTranslated}
                    </DropZone>
                  </div>
                </div>
              </td>
            )}
          </tr>

          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Video Ogg (Mobile)
              </Text>
            </td>
            <td>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                }}
              >
                <div style={{ float: "left" }}>
                  <Thumbnail
                    size="large"
                    source={
                      findArrayElementByLanguage(data, "en") &&
                      findArrayElementByLanguage(data, "en").image_ogg_mobile
                        ? findArrayElementByLanguage(data, "en")
                            .image_ogg_mobile
                        : ""
                    }
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    marginLeft: "10px",
                  }}
                >
                  <DropZone
                    accept=".ogg"
                    //   type="file"
                    allowMultiple={false}
                    onDrop={handleDropZoneDropOggMobile}
                    onDropAccepted={sendFileOggMobile}
                  >
                    {uploadedFileOggMobile}
                    {fileUploadOggMobile}
                  </DropZone>
                </div>
              </div>
            </td>
            {translatedButtonClicked && (
              <td>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                  }}
                >
                  <div style={{ float: "left" }}>
                    <Thumbnail
                      size="large"
                      source={
                        findArrayElementByLanguage(data, selectedLanguage) &&
                        findArrayElementByLanguage(data, selectedLanguage)
                          .image_ogg_mobile
                          ? findArrayElementByLanguage(data, selectedLanguage)
                              .image_ogg_mobile
                          : ""
                      }
                    />
                  </div>
                  <div
                    style={{
                      width: "100%",
                      marginLeft: "10px",
                    }}
                  >
                    <DropZone
                      accept=".ogg"
                      //   type="file"
                      allowMultiple={false}
                      onDrop={handleDropZoneDropOggTranslatedMobile}
                      onDropAccepted={sendFileOggTranslatedMobile}
                    >
                      {uploadedFileOggTranslatedMobile}
                      {fileUploadOggTranslatedMobile}
                    </DropZone>
                  </div>
                </div>
              </td>
            )}
          </tr>

          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Link Webm
              </Text>
            </td>
            <td>
              <TextField
                value={
                  findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").link_webm
                }
                onChange={handleChangeLinkWebm}
                disabled={translatedButtonClicked}
              />
            </td>
            {translatedButtonClicked && (
              <td>
                <TextField
                  value={
                    findArrayElementByLanguage(data, selectedLanguage) &&
                    findArrayElementByLanguage(data, selectedLanguage).link_webm
                  }
                  onChange={handleChangeLinkWebmTranslated}
                />
              </td>
            )}
          </tr>

          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Video Webm (Desktop)
              </Text>
            </td>
            <td>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                }}
              >
                <div style={{ float: "left" }}>
                  <Thumbnail
                    size="large"
                    source={
                      findArrayElementByLanguage(data, "en") &&
                      findArrayElementByLanguage(data, "en").image_webm
                        ? findArrayElementByLanguage(data, "en").image_webm
                        : ""
                    }
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    marginLeft: "10px",
                  }}
                >
                  <DropZone
                    accept=".webm"
                    //   type="file"
                    allowMultiple={false}
                    onDrop={handleDropZoneDropWebm}
                    onDropAccepted={sendFileWebm}
                  >
                    {uploadedFileWebm}
                    {fileUploadWebm}
                  </DropZone>
                </div>
              </div>
            </td>
            {translatedButtonClicked && (
              <td>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                  }}
                >
                  <div style={{ float: "left" }}>
                    <Thumbnail
                      size="large"
                      source={
                        findArrayElementByLanguage(data, selectedLanguage) &&
                        findArrayElementByLanguage(data, selectedLanguage)
                          .image_webm
                          ? findArrayElementByLanguage(data, selectedLanguage)
                              .image_webm
                          : ""
                      }
                    />
                  </div>
                  <div
                    style={{
                      width: "100%",
                      marginLeft: "10px",
                    }}
                  >
                    <DropZone
                      accept=".webm"
                      //   type="file"
                      allowMultiple={false}
                      onDrop={handleDropZoneDropWebmTranslated}
                      onDropAccepted={sendFileWebmTranslated}
                    >
                      {uploadedFileWebmTranslated}
                      {fileUploadWebmTranslated}
                    </DropZone>
                  </div>
                </div>
              </td>
            )}
          </tr>

          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Video Webm (Mobile)
              </Text>
            </td>
            <td>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                }}
              >
                <div style={{ float: "left" }}>
                  <Thumbnail
                    size="large"
                    source={
                      findArrayElementByLanguage(data, "en") &&
                      findArrayElementByLanguage(data, "en").image_webm_mobile
                        ? findArrayElementByLanguage(data, "en")
                            .image_webm_mobile
                        : ""
                    }
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    marginLeft: "10px",
                  }}
                >
                  <DropZone
                    accept=".webm"
                    //   type="file"
                    allowMultiple={false}
                    onDrop={handleDropZoneDropWebmMobile}
                    onDropAccepted={sendFileWebmMobile}
                  >
                    {uploadedFileWebmMobile}
                    {fileUploadWebmMobile}
                  </DropZone>
                </div>
              </div>
            </td>
            {translatedButtonClicked && (
              <td>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                  }}
                >
                  <div style={{ float: "left" }}>
                    <Thumbnail
                      size="large"
                      source={
                        findArrayElementByLanguage(data, selectedLanguage) &&
                        findArrayElementByLanguage(data, selectedLanguage)
                          .image_webm_mobile
                          ? findArrayElementByLanguage(data, selectedLanguage)
                              .image_webm_mobile
                          : ""
                      }
                    />
                  </div>
                  <div
                    style={{
                      width: "100%",
                      marginLeft: "10px",
                    }}
                  >
                    <DropZone
                      accept=".webm"
                      //   type="file"
                      allowMultiple={false}
                      onDrop={handleDropZoneDropWebmTranslatedMobile}
                      onDropAccepted={sendFileWebmTranslatedMobile}
                    >
                      {uploadedFileWebmTranslatedMobile}
                      {fileUploadWebmTranslatedMobile}
                    </DropZone>
                  </div>
                </div>
              </td>
            )}
          </tr>

          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Vimeo Id
              </Text>
            </td>
            <td>
              <TextField
                value={
                  findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").vimeo_id
                }
                onChange={handleChangeVimeoId}
                disabled={translatedButtonClicked}
              />
            </td>
            {translatedButtonClicked && (
              <td>
                <TextField
                  value={
                    findArrayElementByLanguage(data, selectedLanguage) &&
                    findArrayElementByLanguage(data, selectedLanguage).vimeo_id
                  }
                  onChange={handleChangeVimeoIdranslated}
                />
              </td>
            )}
          </tr>

          {/* <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Image
              </Text>
            </td>
            <td>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                }}
              >
                <div style={{ float: "left" }}>
                  <Thumbnail
                    size="large"
                    source={
                      findArrayElementByLanguage(data, "en") &&
                      findArrayElementByLanguage(data, "en").image
                        ? findArrayElementByLanguage(data, "en").image
                        : ""
                    }
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    marginLeft: "10px",
                  }}
                >
                  <DropZone
                    accept=".png,.jpeg,.jpg,.svg,.json"
                    //   type="file"
                    allowMultiple={false}
                    onDrop={handleDropZoneDrop}
                    onDropAccepted={sendImage}
                  >
                    {uploadedFile}
                    {fileUpload}
                  </DropZone>
                </div>
              </div>
            </td>
            {translatedButtonClicked && (
              <td>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                  }}
                >
                  <div style={{ float: "left" }}>
                    <Thumbnail
                      size="large"
                      source={
                        findArrayElementByLanguage(data, selectedLanguage) &&
                        findArrayElementByLanguage(data, selectedLanguage).image
                          ? findArrayElementByLanguage(data, selectedLanguage)
                              .image
                          : ""
                      }
                    />
                  </div>
                  <div
                    style={{
                      width: "100%",
                      marginLeft: "10px",
                    }}
                  >
                    <DropZone
                      accept=".png,.jpeg,.jpg,.svg,.json"
                      //   type="file"
                      allowMultiple={false}
                      onDrop={handleDropZoneDropTranslated}
                      onDropAccepted={sendImageTranslated}
                    >
                      {uploadedFileTranslated}
                      {fileUploadTranslated}
                    </DropZone>
                  </div>
                </div>
              </td>
            )}
          </tr> */}

          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Thumbnail (Desktop)
              </Text>
            </td>
            <td>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                }}
              >
                <div style={{ float: "left" }}>
                  <Thumbnail
                    size="large"
                    source={
                      findArrayElementByLanguage(data, "en") &&
                      findArrayElementByLanguage(data, "en").image
                        ? findArrayElementByLanguage(data, "en").image
                        : ""
                    }
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    marginLeft: "10px",
                  }}
                >
                  <DropZone
                    accept=".png,.jpeg,.jpg,.svg,.json"
                    //   type="file"
                    allowMultiple={false}
                    onDrop={handleDropZoneDrop}
                    onDropAccepted={sendImage}
                  >
                    {uploadedFile}
                    {fileUpload}
                  </DropZone>
                </div>
              </div>
              {/* <div className="mt-2">
                <Button
                  outline
                  size="slim"
                  destructive
                  onClick={() => handleDeleteImage("image", "en")}
                >
                  Delete Image
                </Button>
              </div> */}
            </td>
            {translatedButtonClicked && (
              <td>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                  }}
                >
                  <div style={{ float: "left" }}>
                    <Thumbnail
                      size="large"
                      source={
                        findArrayElementByLanguage(data, selectedLanguage) &&
                        findArrayElementByLanguage(data, selectedLanguage).image
                          ? findArrayElementByLanguage(data, selectedLanguage)
                              .image
                          : ""
                      }
                    />
                  </div>
                  <div
                    style={{
                      width: "100%",
                      marginLeft: "10px",
                    }}
                  >
                    {/* <DropZone
                      accept=".png,.jpeg,.jpg,.svg,.json"
                      //   type="file"
                      allowMultiple={false}
                      onDrop={handleDropZoneDropTranslated}
                      onDropAccepted={sendImageTranslated}
                    >
                      {uploadedFileTranslated}
                      {fileUploadTranslated}
                    </DropZone> */}

                    <DropZone
                      accept=".png,.jpeg,.jpg,.svg,.json"
                      //   type="file"
                      allowMultiple={false}
                      onDrop={handleDropZoneDropTranslated}
                      onDropAccepted={sendImageTranslated}
                    >
                      {uploadedFileTranslated}
                      {fileUploadTranslated}
                    </DropZone>
                  </div>
                </div>
                {/* <div className="mt-2">
                  <Button
                    outline
                    size="slim"
                    destructive
                    onClick={() => handleDeleteImage("image", selectedLanguage)}
                  >
                    Delete Image
                  </Button>
                </div> */}
              </td>
            )}
          </tr>

          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Thumbnail (Mobile)
              </Text>
            </td>
            <td>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                }}
              >
                <div style={{ float: "left" }}>
                  <Thumbnail
                    size="large"
                    source={
                      findArrayElementByLanguage(data, "en") &&
                      findArrayElementByLanguage(data, "en").image_mobile
                        ? findArrayElementByLanguage(data, "en").image_mobile
                        : ""
                    }
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    marginLeft: "10px",
                  }}
                >
                  <DropZone
                    accept=".png,.jpeg,.jpg,.svg,.json"
                    //   type="file"
                    allowMultiple={false}
                    onDrop={handleDropZoneDropMobile}
                    onDropAccepted={sendImageMobile}
                  >
                    {uploadedFileMobile}
                    {fileUploadMobile}
                  </DropZone>
                </div>
              </div>
              {/* <div className="mt-2">
                <Button
                  outline
                  size="slim"
                  destructive
                  onClick={() => handleDeleteImage("image", "en")}
                >
                  Delete Image
                </Button>
              </div> */}
            </td>
            {translatedButtonClicked && (
              <td>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                  }}
                >
                  <div style={{ float: "left" }}>
                    <Thumbnail
                      size="large"
                      source={
                        findArrayElementByLanguage(data, selectedLanguage) &&
                        findArrayElementByLanguage(data, selectedLanguage)
                          .image_mobile
                          ? findArrayElementByLanguage(data, selectedLanguage)
                              .image_mobile
                          : ""
                      }
                    />
                  </div>
                  <div
                    style={{
                      width: "100%",
                      marginLeft: "10px",
                    }}
                  >
                    {/* <DropZone
                      accept=".png,.jpeg,.jpg,.svg,.json"
                      //   type="file"
                      allowMultiple={false}
                      onDrop={handleDropZoneDropTranslated}
                      onDropAccepted={sendImageTranslated}
                    >
                      {uploadedFileTranslated}
                      {fileUploadTranslated}
                    </DropZone> */}

                    <DropZone
                      accept=".png,.jpeg,.jpg,.svg,.json"
                      //   type="file"
                      allowMultiple={false}
                      onDrop={handleDropZoneDropTranslatedMobile}
                      onDropAccepted={sendImageTranslatedMobile}
                    >
                      {uploadedFileTranslatedMobile}
                      {fileUploadTranslatedMobile}
                    </DropZone>
                  </div>
                </div>
                {/* <div className="mt-2">
                  <Button
                    outline
                    size="slim"
                    destructive
                    onClick={() => handleDeleteImage("image", selectedLanguage)}
                  >
                    Delete Image
                  </Button>
                </div> */}
              </td>
            )}
          </tr>
        </tbody>
      </table>
      {/* <Text variant="bodyMd" as="p" fontWeight="medium">
        Image Position
      </Text>
      <Select
        options={optionsPosition}
        value={
          findArrayElementByLanguage(data, "en") &&
          findArrayElementByLanguage(data, "en").position
        }
        onChange={handleSelectChangePosition}
        error={positionError}
        placeholder="Please select"
      /> */}
      <Text>Template: </Text>
      <div className="boxTemplates">
        {props.templates?.length ? (
          props.templates.map((item, index) => {
            return (
              <div
                style={{ marginRight: "1rem" }}
                key={item.id}
                onClick={() => handleChangeTemplate(item.id)}
                className={`divTemplate ${
                  findArrayElementByLanguage(data, "en")
                    ? String(
                        findArrayElementByLanguage(data, "en").template
                      ) === String(item.id) && "borderTemplate"
                    : ""
                }`}
              >
                {item.text && (
                  <div className="templateInstruction">
                    <Tooltip content={item.text}>
                      <img
                        src={instructionImg}
                        width={17}
                        className="templateInstruction"
                      />
                    </Tooltip>
                  </div>
                )}

                <div className="buttonTemplate">
                  {item.image && <img src={item.image} width={30}></img>}
                  <div style={{ marginTop: "0.2rem" }}>
                    <Text color="subdued">{item.description}</Text>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <Text color="subdued">No templates added for this section type</Text>
        )}
      </div>

      <Checkbox
        label="Is Active"
        checked={
          findArrayElementByLanguage(data, "en") &&
          findArrayElementByLanguage(data, "en").active
        }
        onChange={handleChange}
      />
      <FormLayout.Group>
        <div style={{ float: "right" }}>
          <Button
             variant="primary"
            onClick={handleSave}
            loading={props.isSaving}
            disabled={!accessEditSections()}
          >
            Save
          </Button>
        </div>
      </FormLayout.Group>
      {isImageUploading ? <LoadingScreen /> : null}
    </FormLayout>
  );
  function handleSave() {
    // if (
    //   findArrayElementByLanguage(data, "en") &&
    //   !findArrayElementByLanguage(data, "en").position
    // ) {
    //   !findArrayElementByLanguage(data, "en").position &&
    //     setPositionError("Please select an image position");
    // } else {
    props.handleSavingState();
    const form_data = new FormData();
    findArrayElementByLanguage(data, "en") &&
      (findArrayElementByLanguage(data, "en").template === "none"
        ? form_data.append(`template_id`, "")
        : form_data.append(
            `template_id`,
            findArrayElementByLanguage(data, "en").template
          ));

    data.forEach((selected, index) =>
      form_data.append(`title[${selected.language}]`, selected.title)
    );

    data.forEach((selected, index) =>
      form_data.append(`subtitle[${selected.language}]`, selected.subtitle)
    );
    form_data.append("is_active", data[data.length - 1].active ? 1 : 0);
    form_data.append("is_autoplay", data[data.length - 1].autoplay ? 1 : 0);

    form_data.append("_method", "PATCH");
    data.forEach(
      (selected, index) =>
        selected.video_mp4 &&
        form_data.append(`file_mp4[${selected.language}]`, selected.video_mp4)
    );
    data.forEach(
      (selected, index) =>
        selected.video_ogg &&
        form_data.append(`file_ogg[${selected.language}]`, selected.video_ogg)
    );
    data.forEach(
      (selected, index) =>
        selected.video_webm &&
        form_data.append(`file_webm[${selected.language}]`, selected.video_webm)
    );

    data.forEach(
      (selected, index) =>
        selected.video_mp4_mobile &&
        form_data.append(
          `mobile_file_mp4[${selected.language}]`,
          selected.video_mp4_mobile
        )
    );
    data.forEach(
      (selected, index) =>
        selected.video_ogg_mobile &&
        form_data.append(
          `mobile_file_ogg[${selected.language}]`,
          selected.video_ogg_mobile
        )
    );
    data.forEach(
      (selected, index) =>
        selected.video_webm_mobile &&
        form_data.append(
          `mobile_file_webm[${selected.language}]`,
          selected.video_webm_mobile
        )
    );

    data.forEach((selected, index) =>
      form_data.append(`link_mp4[${selected.language}]`, selected.link_mp4)
    );
    data.forEach((selected, index) =>
      form_data.append(`link_ogg[${selected.language}]`, selected.link_ogg)
    );
    data.forEach((selected, index) =>
      form_data.append(`link_webm[${selected.language}]`, selected.link_webm)
    );
    data.forEach((selected, index) =>
      form_data.append(`vimeo_id[${selected.language}]`, selected.vimeo_id)
    );
    props.selectedChannels && props.selectedChannels.length
      ? props.selectedChannels.forEach((selected, index) =>
          form_data.append(`channels[${index}]`, selected)
        )
      : form_data.append(`channels`, []);
    data.forEach((selected, index) =>
      form_data.append(`thumbnail[${selected.language}]`, selected.fileImage)
    );
    data.forEach((selected, index) =>
      form_data.append(
        `mobile_thumbnail[${selected.language}]`,
        selected.fileImage_mobile
      )
    );
    axios
      .post(`/pages/${id}/sections/${props.sectionId}`, form_data)
      .then((res) => {
        props.handleSaveAndRefresh();
      })
      .catch((err) => console.log(""));
    // }
  }
  function findArrayElementByLanguage(array, language) {
    return array.find((element, index) => {
      return element.language === language;
    });
  }
};
export default VideoSection;
